import { apiService } from '../services/apiService';
import { paginationService } from '../services/paginationService';

// Simple wrapper for employee notes API to keep future expansion easy
export interface GetEmployeeNotesParams {
  workplaceId: number;
  date?: string;
}

export const getEmployeeNotes = async ({ workplaceId, date }: GetEmployeeNotesParams): Promise<any> => {
  const queryParams = new URLSearchParams();
  if (workplaceId) {
    queryParams.append('workplace', workplaceId.toString());
  }
  if (date) queryParams.append('date', date);
  return paginationService.getWithHandler(`employee_notes?${queryParams.toString()}`, undefined, 50);
};

export const getEmployeeNoteById = async (id: number): Promise<any> => {
  const response = await apiService.get(`employee_notes/${id}`);
  return apiService.responseHandler(response);
};

export const createEmployeeNote = async (payload: { workplaceId: number; authorId?: number; note: string; date?: string; }): Promise<any> => {
	const cleanNote = payload.note.replace(/<[^>]*>/g, '');
	const body: any = { note: cleanNote };
	// NOTE: API mapping is inconsistent across environments. `author` may represent the assigned-to user
	// while `assignToUser` represents the actual creator in some cases. We allow both fields to be set.
	if (payload.authorId) body.author = `api/users/${payload.authorId}`;
	if (payload.workplaceId) body.workplace = `api/workplaces/${payload.workplaceId}`;
	if (payload.date) body.date = payload.date;

  const response = await apiService.post('employee_notes', body);
  return apiService.responseHandler(response);
};

export const updateEmployeeNote = async (id: number, payload: { workplaceId?: number; authorId?: number; note: string; date?: string; }): Promise<any> => {
	const cleanNote = payload.note.replace(/<[^>]*>/g, '');
	const body: any = { note: cleanNote };
	if (payload.authorId) body.author = `api/users/${payload.authorId}`;
	if (payload.workplaceId) body.workplace = `api/workplaces/${payload.workplaceId}`;
	if (payload.date) body.date = payload.date;

  const response = await apiService.put(`employee_notes/${id}`, body);
  return apiService.responseHandler(response);
};

export const deleteEmployeeNote = async (id: number): Promise<any> => {
  const response = await apiService.delete(`employee_notes/${id}`);
  return apiService.responseHandler(response);
};

export const employeeNotesService = {
  getEmployeeNotes,
  getEmployeeNoteById,
  createEmployeeNote,
  updateEmployeeNote,
  deleteEmployeeNote,
};

export default employeeNotesService;
